import { Input } from 'antd';
import { useEffect, useState } from 'react';

const PasswordInput = ({ initialValue, save, inputValidator = (e) => e.target.value, ...props }) => {
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  return (
    <Input.Password
      allowClear
      value={value}
      disabled={loading}
      {...props}
    />
  );
};

export default PasswordInput;